<template>
  <div>
    <v-card max-width="300" elevation="0">
      <v-card-text class="pa-0">
        <v-card-text class="color-wallet" fill-dot rigth>
          <span style="color: #FFFFFF">{{
            dinheiro
              ? new Intl.NumberFormat("de-DE").format(dinheiro) + " Kzs"
              : ""
          }}</span>
        </v-card-text>
        <v-form novalidate ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="dinheiro"
            :rules="moneyTrans"
            label="Valor que deseja carregar (Kz)"
            required
            filled
            :disabled="disabled"
            type="number"
            min="0"
            autofocus
          ></v-text-field>
          <v-text-field
            v-model="account"
            :rules="refRules"
            label="Nº da Conta Kyami"
            required
            filled
            :disabled="disabled"
          ></v-text-field>
          <v-card-actions>
            <v-btn
              color="deep-purple lighten-2"
              text
              block
              @click="setConfirmTrans"
              :loading="loading"
            >
              <v-icon>mdi-transfer-left</v-icon>
              Transferir
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "FormTransferWalletEnterprise",
  data: () => ({
    disabled: false,
    showNotify: false,
    dialog: false,
    account: "",
    dinheiro: "",
    valid: true,
    value: true,
    loading: false,
    refRules: [
      v => !!v || "Conta é obrigatória",
      v =>
        /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(
          v
        ) || "Conta inválida",
      v => (v && v.length >= 12) || "Conta inválida"
    ],
    moneyTrans: [
      v => !!v || "Este campo é requerido",
      v => /(^[0-9]*$)/.test(v) || "Valor requerido",
      v => /^([1-9][0-9]{3,6})$/gim.test(v) || "Entre 1.000 a 5.000.000",
      v => v <= 5000000 || "Entre 1.000 a 5.000.000"
    ]
  }),
  methods: {
    setConfirmTrans() {
      if (this.$refs.form.validate()) {
        const payload = {
          target: true,
          close: false,
          amount: this.dinheiro,
          ck: this.account
        };
        this.$store.dispatch("confirmTransferToAnotherWalletE", payload);
      }
    }
  }
};
</script>

<style scoped>
.color-wallet {
  min-height: 80px;
  background-color: #26a69a;
  text-align: center;
  padding-top: 31px;
  display: block;
  font-size: 18px;
}
</style>
